import { Autocomplete, Box, Button, TextField, Typography, Chip, CircularProgress } from "@mui/material";
import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import styled from "@emotion/styled";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ContentBox from "../../../components/ui/ContentBox";

import UserType from "../../../components/ui/UserType";
import TableShowUser from "../../../components/ui/TableShowUser";
import ButtonSquare from "../../../components/ui/ButtonSquare";
import { useNavigate } from "react-router-dom";
import Api from "../../../api/Api";
import { Urls } from "../../../api/Urls";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { purchases_columns } from "../../../components/data/purchaseColumns";
import { purchases_rows } from "../../../components/data/purchaseRows";
import moment from "moment";
import BreadcrumComp from "../../../components/ui/BreadcrumComp";
import { purchases_columns_client } from "../../../components/data/purchaseColumnsClient";

function UserPurchases({ id }) {
  useEffect(() => {
    document.title = "BTA admin - Store / Purchases";
  }, []);
  const { user } = useAuthContext();
  const access_token = user?.access_token;
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");

  const perPage = "?perPage=10";

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "white",
      paddingTop: "8px",
      paddingBottom: "8px",
      letterSpacing: "1px",
      color: `#4B465C`,
      fontSize: 13,
      fontWeight: 500,
    },
    [`&.${tableCellClasses.body}`]: {
      background: "white",
      fontSize: 14,
      color: `#666D83`,
      fontWeight: "500",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
    ":hover": {
      filter: "brightness(0.95)",
    },
    cursor: "pointer",
  }));

  const StyledTable = styled(Table)({
    borderRadius: "0px",
  });
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };
  const [orders, setOrders] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Api.get(Urls.GET_USERS_ORDERS + id + "/orders", {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
      .then((res) => {
        setOrders(res?.data?.data);
        setData(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  }, []);
  const handlePagination = (link) => {
    //console.log("getting data");
    Api.get(`${link}`, {
      headers: { "Content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
      .then((res) => {
        //console.log("RESULTAT MATCHED offres DATA", res?.data);
        //console.log("RESPONES GHERBI", res);
        setData(res?.data);
        setOrders(res.data?.data);
        //console.log(res?.data?.meta?.links, "link pag");
      })
      .catch((err) => {
        //console.log(err);
        setOrders([]);
      });
  };
  return (
    <>
      <ToastContainer />
      <Box display="flex" flexDirection="column" gap="26px" marginTop="26px">
        <Box>
          <BreadcrumComp first="Store" second="Purchases" />
        </Box>
        <ContentBox>
          <Box display="flex" flexDirection="column" gap="16px">
            <Box>
              <Typography fontSize="18px" fontWeight="500" lineHeight="24px" color="#4B465C">
                Purchases
              </Typography>
            </Box>
            <Box marginTop="8px" display="flex" flexWrap="wrap" gap="16px" flexDirection="row">
              <TextField value={search} onChange={handleSearchChange} type="input" placeholder="Search purchase" />
              <Autocomplete
                sx={{ minWidth: "300px" }}
                options={["Confirmed"]}
                getOptionLabel={(e) => e}
                onChange={(event, value) => {
                  if (value !== null) {
                    //console.log("selecting facture state value", value);
                    //console.log("selecting facture state value", value.id);
                    setStatus(value);
                    //console.log("selectedFicheDePaieState", selectedFicheDePaieState);
                  } else {
                    setStatus(null);
                  }
                }}
                renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Status" />}
              />
            </Box>
            {loading && (
              <Box display="flex" justifyContent="center">
                <CircularProgress />
              </Box>
            )}
            {!loading && (
              <TableContainer sx={{ borderRadius: "0px", border: `1px solid #DBDADE` }}>
                <StyledTable aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      {purchases_columns_client.map((col, index) => (
                        <StyledTableCell key={index} width={col.width} align={col.align}>
                          {col.name}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orders?.map((purchase) => (
                      <StyledTableRow key={purchase?.id}>
                        <StyledTableCell onClick={() => navigate(`/admin/purchases/${purchase.id}`)} align="left">
                          <Typography fontWeight="400" color="#3890E2" fontSize="15px">
                            #{purchase?.id}
                          </Typography>
                        </StyledTableCell>

                        <StyledTableCell onClick={() => navigate(`/admin/purchases/${purchase.id}`)} align="left">
                          {parseFloat(purchase?.total).toLocaleString("fr-FR")} BHD
                        </StyledTableCell>
                        <StyledTableCell onClick={() => navigate(`/admin/purchases/${purchase.id}`)} align="left">
                          {moment(purchase.date).format("DD MMMM YYYY")}
                        </StyledTableCell>
                        <StyledTableCell onClick={() => navigate(`/admin/purchases/${purchase.id}`)} align="left">
                          {purchase.created_at}
                        </StyledTableCell>
                        <StyledTableCell onClick={() => navigate(`/admin/purchases/${purchase.id}`)} align="center">
                          <Box>
                            {(purchase?.status === "PAID" || purchase?.status === "CANCELED") && <Chip label={purchase?.status === "PAID" ? "PAID" : "CANCELED"} sx={{ backgroundColor: `${purchase?.status === "PAID" ? "rgba(40, 199, 111, 0.16)" : "rgba(234, 84, 85, 0.16)"}`, color: `${purchase?.status === "PAID" ? "rgba(40, 199, 111, 1)" : "rgba(234, 84, 85, 1)"}`, borderRadius: "8px" }} />}
                            {purchase?.status === "PENDING" && <Chip label={"PENDING"} sx={{ backgroundColor: "rgba(255, 213, 128 , 0.5)", color: "orange", borderRadius: "8px" }} />}
                          </Box>{" "}
                        </StyledTableCell>

                        <StyledTableCell align="left">
                          <Box justifyContent="left" display="flex" gap="2px">
                            <ButtonSquare onClick={() => navigate(`/admin/purchases/${purchase.id}`)} action="show" />
                            <ButtonSquare action="3points" />
                          </Box>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </StyledTable>
              </TableContainer>
            )}
            {orders?.length === 0 && !loading && <Typography textAlign="center">No orders</Typography>}
            {orders?.length > 0 && (
              <Box justifyContent="flex-end" display="flex" gap="4px">
                {data?.links?.prev && (
                  <ButtonSquare
                    onClick={() => {
                      handlePagination(data?.links?.prev);
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                    action="Previous"
                  />
                )}
                <Box display="flex" gap="4px" justifyContent="center">
                  {data?.meta?.links?.map((link) => (
                    <ButtonSquare
                      onClick={() => {
                        handlePagination(link.url);
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                      action={link?.active ? "number-active" : "number"}
                      number={link.label}
                    />
                  ))}
                </Box>
                {data?.links?.next && (
                  <ButtonSquare
                    onClick={() => {
                      handlePagination(data?.links?.next);
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                    action="Next"
                  />
                )}
              </Box>
            )}
          </Box>
        </ContentBox>
      </Box>
    </>
  );
}

export default UserPurchases;
